export * from './delete-feld-kategorie-request.interface';
export * from './delete-feld-kategorie-response.interface';
export * from './delete-feld-kategorie.shapes';
